// extracted by mini-css-extract-plugin
module.exports = {"container":"_1gBK4oH3 flex flex-column items-center justify-center","message":"_3EqV1boU","name":"_3WXBUeJ8","category":"_3H3hpaTC"};